import { JointCreditManager } from './joint-credit-manager.class';

/** Joint credit select validation */
export class JointCreditValidation {
  constructor(private readonly jointCreditManager: JointCreditManager) {}

  /**
   * There should be at least one pair of joint applicant
   */
  public get validateJointCreditRequired(): boolean {
    return this.jointCreditManager.maxNumberOfJointPair > 0 && this.jointCreditManager.allApplicants.filter((a) => !!a.parentId).length > 0;
  }

  /**
   * Joint pair selection cannot be same, if valid (there is not applicant are same) return true
   */
  public get validationDuplicateSelection(): boolean {
    const anyJointPareThatIsSame = this.jointCreditManager.jointApplicants.find((j) => j.areParentAndApplicantSame);
    return anyJointPareThatIsSame ? false : true;
  }
}
